import React from "react";
import { useState } from "react";
import { SignGenerator } from "./sign-generator/SignGenerator";
import { ISignGenerate } from "../interfaces/ISignGenerate";
import { LandingPage } from "./LandingPage";

export const Content = () => {
  const [generateSign, setGenerateSign] = useState<ISignGenerate>({
    generate: false,
    defaultValues: null,
  });
  return (
    <div>
      {generateSign.generate ? (
        <SignGenerator
          generateSign={generateSign}
          setGenerateSign={setGenerateSign}
        />
      ) : (
        <LandingPage setGenerateSign={setGenerateSign} />
      )}
    </div>
  );
};
